<template>
  <router-link :to="{name: PATHS_NAME.TWITTER_HYPE}" class="Drop-Menu-Item">Твиттер Хайп</router-link>
</template>

<script setup>
  import { PATHS_NAME } from "@shared/routers/consts/pathsName";
</script>

<style lang="scss">
  @import '../../../../styles/Drop-Menu-Item.scss';
</style>
